import { setOrm } from 'common-src/features/orm';
import orm from 'common-src/orm';

import { store } from 'src/store';

import DashboardV2Task from './DashboardV2Task';

const normalizeTask = (task) => {
  const patient = task?.patient || {};

  return {
    id: task.id,
    patientId: task.patientId ?? task.patient_id ?? patient.patientId ?? patient.patient_id,
    patient,
    typeId: task.typeId ?? task.type_id ?? null,
    reasonId: task.reasonId ?? task.reason_id ?? null,
    departmentAthenaId: task.departmentAthenaId ?? task.department_athena_id ?? null,
    workflowInstanceId: task.workflowInstanceId ?? task.workflow_instance_id ?? null,
    title: task.title,
    caption: task.caption ?? null,
    status: task.status,
    priority: task.priority,
    team: task.team,
    owner: task.owner,
    role: task.role ?? null,
    pathway: task.pathway,
    protocol: task.protocol,
    mustHave2026: task.mustHave2026 ?? task.must_have2026 ?? false,
    due: task.due,
    noteUrl: task.noteUrl ?? task.note_url ?? null,
    taskSop: task.taskSop ?? task.task_sop ?? null,
    threadId: task.threadId ?? task.thread_id ?? null,
    isRead: task.isRead ?? task.is_read ?? false,
    externalObjectType: task.externalObjectType ?? task.external_object_type ?? null,
    externalObjectId: task.externalObjectId ?? task.external_object_id ?? null,
    evidence: task.evidence ?? null,
    callbackStatus: task.callbackStatus ?? task.callback_status ?? null,
    isVisible: task.isVisible ?? task.is_visible ?? true,
  };
};

export const syncDashboardV2TaskQueue = (responseBody) => {
  const tasks = responseBody?.data || [];
  const rootOrm = store.getState().orm;
  const session = orm.session(rootOrm);
  const modelClass = session[DashboardV2Task.modelName];

  modelClass.all().delete();
  tasks.forEach((task) => {
    modelClass.upsert(normalizeTask(task));
  });

  store.dispatch(setOrm(session.state));
};
